var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup79(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 70,
    viewBox: "0 0 28 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1673 67.5L20.5005 37.8784M20.5005 37.8784V67.5M2.50049 28.0161L9.8842 26.4677L20.5005 19.5V37.8784M20.5005 19.5L14.5476 34.2097L6.77527 37.8784",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5005 6.49989C16.5005 7.56076 16.9746 8.57817 17.8185 9.32832C18.6624 10.0785 19.807 10.4999 21.0005 10.4999C22.194 10.4999 23.3386 10.0785 24.1825 9.32832C25.0264 8.57817 25.5005 7.56076 25.5005 6.49989C25.5005 5.43903 25.0264 4.42161 24.1825 3.67147C23.3386 2.92132 22.194 2.49989 21.0005 2.49989C19.807 2.49989 18.6624 2.92132 17.8185 3.67147C16.9746 4.42161 16.5005 5.43903 16.5005 6.49989Z",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup79);
export default __webpack_public_path__ + "static/media/Group 79.f52976983083d9f3c3afa3e11741bf80.svg";
export { ForwardRef as ReactComponent };